export enum drawingOptionEnums {
  PER_DRAWING = 'perDrawing',
  PER_FACTORY_DRAWING = 'perFactoryDrawing',
}
